import { Lens } from "monocle-ts";

import { type MetricField } from "../../../gql-generated/types";

import { type DimensionFunnel, type DimensionFunnelMap, type FunnelItem } from "./DimensionFunnelMap";

export const valueLens = Lens.fromProp<FunnelItem>()("value");
export const labelLens = Lens.fromProp<FunnelItem>()("label");
export const labelPreviousLens = Lens.fromProp<FunnelItem>()("labelPrevious");
export const isMapEmptyLens = Lens.fromProp<FunnelItem>()("isMapEmpty");
export const valueFormattedLens = Lens.fromProp<FunnelItem>()("valueFormatted");
export const fractionFromPreviousPercentLens = Lens.fromProp<FunnelItem>()("fractionFromPreviousPercent");
export const fractionFromPreviousPercentFormattedLens = Lens.fromProp<FunnelItem>()(
    "fractionFromPreviousPercentFormatted",
);
export const fractionFromTotalPercentLens = Lens.fromProp<FunnelItem>()("fractionFromTotalPercent");
export const fractionFromTotalPercentFormattedLens = Lens.fromProp<FunnelItem>()("fractionFromTotalPercentFormatted");

export const makeDimensionLens = (dimension: string): Lens<DimensionFunnelMap, DimensionFunnel> =>
    Lens.fromProp<DimensionFunnelMap>()(dimension);

// TODO(kkold) - Fix optionals
export const makeFunnelItemLens = (
    dimensionBreakdown: string,
    metricField: MetricField,
): Lens<DimensionFunnel, FunnelItem | undefined> => Lens.fromPath<DimensionFunnel>()([dimensionBreakdown, metricField]);
